import { render, staticRenderFns } from "./ChatGPTForm.vue?vue&type=template&id=65250cbe"
import script from "./ChatGPTForm.vue?vue&type=script&lang=js"
export * from "./ChatGPTForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports